"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ganttlab_entities_1 = require("ganttlab-entities");
var ViewRepositoryGitHubStrategy_1 = require("./strategies/ViewRepositoryGitHubStrategy");
var ViewRepository = /** @class */ (function (_super) {
    __extends(ViewRepository, _super);
    function ViewRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.slug = 'repository';
        _this.name = 'By repository';
        _this.shortDescription = 'Issues within a repository';
        _this.slugStrategies = {
            github: new ViewRepositoryGitHubStrategy_1.ViewRepositoryGitHubStrategy(),
        };
        _this.configuration = {
            project: null,
            tasks: {
                page: 1,
                pageSize: 50,
            },
        };
        return _this;
    }
    ViewRepository.prototype.setSort = function (sort) {
        throw new Error('Method not implemented.');
    };
    ViewRepository.prototype.reverseSort = function () {
        throw new Error('Method not implemented.');
    };
    ViewRepository.prototype.setFilter = function (filter) {
        throw new Error('Method not implemented.');
    };
    return ViewRepository;
}(ganttlab_entities_1.SourceVisitor));
exports.ViewRepository = ViewRepository;
//# sourceMappingURL=ViewRepository.js.map